import React from "react";
import "../FormTemplates.css";
import bg_template1 from "./EmployeeRightsTemplate1.png";
import bg_template2 from "./EmployeeRightsTemplate2.png";
import OverlayField from "../OverlayField";


export default function EmployeeRightsTemplate({ data, isDownload = false }) {
  const downloadStyles = { fontSize: '14px' };
  const previewStyles = { fontSize: '9px' };

  return (
    <>
      <div className={isDownload ? "w4-wrapper-download" : "w4-wrapper-preview"} style={isDownload ? downloadStyles : previewStyles}>
        <img src={bg_template1} alt="W4 Form" className="w4-bg" />

        {/* Filled details -- widths are the gap to whatever sits next on the
            same row, or the page's right margin -- see OverlayField.js. */}
        <OverlayField isDownload={isDownload} d={{ top: "955px", left: "205px", width: 250 }} p={{ top: "430px", left: "92px", width: 117 }}>
          {data?.firstName || ''} {data?.middleName || ''} {data?.lastName || ''}
        </OverlayField>
        <OverlayField isDownload={isDownload} d={{ top: "958px", left: "465px", width: 275 }} p={{ top: "432px", left: "213px", width: 118 }}>
          {new Date().toLocaleDateString()}
        </OverlayField>
        {data.signatureBase64 && <div className="overlay" style={isDownload ? { top: "978px", left: "230px" } : { top: "440px", left: "110px" }}>
          <img
            src={`${data.signatureBase64}`}
            alt="signature"
            style={isDownload ? { maxHeight: 50, maxWidth: 150 } : { maxHeight: 20, maxWidth: 70 }}
          />
        </div>}
      </div>
      
      <div style={{ width: '100%', height: '10px' }}></div>

      <div className={isDownload ? "w4-wrapper-download" : "w4-wrapper-preview"} style={isDownload ? downloadStyles : previewStyles}>
        <img src={bg_template2} alt="W4 Form" className="w4-bg" />
      </div>
    </>
  );
}
